import React from 'react';
import PropTypes from 'prop-types';
import { replaceCitations } from '@Utils/String';
import Button from '@Components/Button';
import useEditInQueryBuilderButtonAttrs from '@Containers/ResultsPreview/hooks/useEditInQueryBuilderButtonAttrs';

function BlockFeedbacks({ previewItem, showStructurePopup, copyQuery, createAlert, showFeedbacks }) {
  const editInQueryBuilderButtonAttrs = useEditInQueryBuilderButtonAttrs(previewItem);

  return (
    <div
      className="quick-results-preview__item_feedback feedback results-preview__block results-preview__block--feedbacks"
      id={previewItem.queryId}>
      {showFeedbacks && (
        <>
          {previewItem.feedbacks.map((feedback) => {
            const title = replaceCitations(feedback.category);
            const capitalizedTitle = title.charAt(0).toUpperCase() + title.slice(1);

            return (
              <div className="feedback__item" key={`${feedback.category}_${feedback.value}`}>
                {feedback.structure && (
                  <div className="feedback__item_title">
                    <span className="feedback__item_title_label">{feedback.category}</span>
                    <span>:</span>
                    <Button
                      onClick={() => showStructurePopup(feedback.structure)}
                      buttonConfig={{
                        type: 'tertiary',
                        size: 'md',
                        iconOnly: true,
                        e2eName: 'quick-results-query-structure',
                      }}
                      iconConfig={{
                        name: 'structure',
                        size: 'sm',
                      }}
                    />
                    <span className="feedback__item_title_value">{feedback.value}</span>
                  </div>
                )}

                {!feedback.structure && (
                  <div className="feedback__item_title">
                    <span className="feedback__item_title_label">{capitalizedTitle}</span>
                    <span>:</span>
                    <span className="feedback__item_title_value">{feedback.value}</span>
                  </div>
                )}
              </div>
            );
          })}
          {previewItem.fullyLoaded && (
            <div className="feedback__buttons">
              <Button
                onClick={() => {
                  copyQuery(previewItem);
                }}
                buttonConfig={{
                  ...editInQueryBuilderButtonAttrs,
                  type: 'link',
                  size: 'sm',
                  iconOnly: true,
                  e2eName: 'edit-qb',
                }}
                iconConfig={{
                  name: 'pencil',
                  size: 'sm',
                }}
              />

              <Button
                onClick={() => {
                  createAlert(previewItem);
                }}
                buttonConfig={{
                  type: 'link',
                  size: 'sm',
                  iconOnly: true,
                  e2eName: 'create-alert',
                  label: 'Create Alert',
                }}
                iconConfig={{
                  name: 'alarm',
                  size: 'sm',
                }}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
}

BlockFeedbacks.defaultProps = {
  showStructurePopup: () => {},
  copyQuery: () => {},
  createAlert: () => {},
};

BlockFeedbacks.propTypes = {
  previewItem: PropTypes.object.isRequired,
  showStructurePopup: PropTypes.func,
  copyQuery: PropTypes.func,
  createAlert: PropTypes.func,
  showFeedbacks: PropTypes.bool,
};

export default BlockFeedbacks;
